import { REVIEW_APP_DOMAIN } from '@shared/constants'

const isReviewAppHost = (hostname: string) =>
  hostname === REVIEW_APP_DOMAIN || hostname.endsWith(`.${REVIEW_APP_DOMAIN}`)

/**
 * Review apps run on `<branch-slug>.intact.review.devebs.net`, a domain the reCAPTCHA
 * site key is not registered for. Calling `grecaptcha.execute()` there yields a token
 * the backend rejects on hostname, so we skip execution entirely and submit
 * `RECAPTCHA_BYPASS_TOKEN` instead, which the auth backend short-circuits.
 *
 * `VITE_APP_ENV` is statically replaced at build time, so production bundles collapse
 * this to `false` and the bypass is minified away.
 */
export const isRecaptchaBypassed = () =>
  import.meta.env.VITE_APP_ENV !== 'production' &&
  isReviewAppHost(window.location.hostname)
